import React from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';

const Navigation = () => {
    const contentLinks = useSelector((state) => state.navigation.contentLinks);
    const featuredItems = useSelector((state) => state.navigation.featuredItems);

    if(contentLinks.length == 0 && (!featuredItems || !featuredItems.enabled)) {
        var el = document.querySelector('.navbar-wrapper');
        if(el) {
            el.classList.add('is-empty');
        }
        return '';
    } else {
        return <NavigationItem links={contentLinks} featuredItems={featuredItems} />;
    }
};

export default Navigation;
